import { useMemo } from 'react';

import useCooperativeId from 'shared/hooks/useCooperativeId';

import useIsConstructor from './useIsConstructor';

const useGetCooperativeCommonCasesListRequestParameters = () => {
  const cooperativeId = useCooperativeId();
  const isConstructor = useIsConstructor();

  return useMemo(
    () => ({ cooperativeId, isConstructor }),
    [cooperativeId, isConstructor]
  );
};

export default useGetCooperativeCommonCasesListRequestParameters;
